// The Q4 research's warnings in the panel header: each heads-up flag ("past opp", "defunct",
// "wrong domain?") as a short orange chip, and the company flag on one truncated line with the
// full text on hover. Renders nothing for an account with no warnings.
import type { BookAccount } from '../api/types';
import { q4Warnings } from '../lib/q4Target';

export function Q4Warnings({ row }: { row: BookAccount }) {
  const { headsUp, companyFlag } = q4Warnings(row.q4_target);
  if (!headsUp.length && !companyFlag) return null;
  return (
    <p className="q4warnings" aria-label="Q4 research warnings">
      <span className="q4warnlabel">Q4 heads-up</span>
      {headsUp.map(text => <span key={text} className="persontag flag">{text}</span>)}
      {companyFlag ? <span className="q4warnnote" title={companyFlag}>{companyFlag}</span> : null}
    </p>
  );
}
